import { useFormContext, type FieldValues } from "react-hook-form";
import styles from "./CustomActivityDuration.module.scss";
import { Trans, useLingui } from "@lingui/react/macro";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import InputField from "@medoma/components/InputField/InputField";
import Select from "@medoma/components/Select/Select";
import {
  customDurationUnitOptions,
  customDurationUnitDictionary,
  type ICustomDurationUnit,
} from "./activityDurationModels";
import { errorMessageAt, withPrefix } from "@/forms/fieldPath";

export type ICustomActivityDurationFields = {
  customDuration: string | null;
  customDurationUnit: ICustomDurationUnit | null;
};

export const CustomActivityDuration = ({
  namePrefix,
}: {
  namePrefix?: string;
}) => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<FieldValues>();

  const customDurationPath = withPrefix(namePrefix, "customDuration");
  const customDurationUnitPath = withPrefix(namePrefix, "customDurationUnit");
  const customDurationError = errorMessageAt(errors, customDurationPath);
  const customDurationUnitError = errorMessageAt(
    errors,
    customDurationUnitPath,
  );

  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>
        <Trans>Annan tid</Trans>
      </legend>
      {customDurationError ? (
        <div className={styles.errorMessage}>
          <ErrorMessage message={customDurationError} weight="bold" />
        </div>
      ) : null}
      {customDurationUnitError ? (
        <div className={styles.errorMessage}>
          <ErrorMessage message={customDurationUnitError} weight="bold" />
        </div>
      ) : null}
      <div className={styles.inputWrapper}>
        <InputField
          label={t`Annan tid`}
          hideLabel
          showOptionalLabel={false}
          type="number"
          outerWidth="fit"
          inputWidth="8ch"
          {...register(customDurationPath, {
            required: {
              value: true,
              message: t`Ange tidsåtgång`,
            },
            min: {
              value: 1,
              message: t`Tidsåtgången måste vara minst 1 minut`,
            },
          })}
        />
        <Select
          label={t`Enhet för tidsåtgång`}
          hideLabel
          {...register(customDurationUnitPath)}
        >
          {customDurationUnitOptions.map((unit) => (
            <option key={unit} value={unit}>
              {t(customDurationUnitDictionary[unit])}
            </option>
          ))}
        </Select>
      </div>
    </fieldset>
  );
};
